import { importanceHigh, importanceNormal, importanceLow, type ResourceId, } from "../components/MailListJumpToPopover.locstring.json";

export const getJumpToImportanceOptions = (): {
    value: string;
    text: ResourceId;
}[] => {
    return [
        {
            value: "High",
            text: importanceHigh,
        },
        {
            value: "Normal",
            text: importanceNormal,
        },
        {
            value: "Low",
            text: importanceLow,
        },
    ];
};
